import { useCallback } from 'react';
import { extractDataFromDOMEvent } from '../utils/extractDataFromDOMEvent';
export var useDatePickerSelectionEvents = function useDatePickerSelectionEvents(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange;
  var onClick = useCallback(function (event) {
    var data = extractDataFromDOMEvent(event);

    if (!data || !data.displayedMonth) {
      return;
    }

    var vector = data.vector;
    onChange(value.clone({
      dateStart: vector,
      dateEnd: vector
    }));
  }, [value, onChange]);
  return {
    dayButtonProps: {
      onClick: onClick
    },
    selectionStartCandidate: null,
    selectionEndCandidate: null
  };
};